import { cva } from 'class-variance-authority';

/**
 * Skeleton class recipes. The fill lives on `.ds-skeleton` in `design-system.css`, so there is no
 * `dark:` variant here.
 *
 * Ported from Figma `Skeleton`, page `Skeleton [Draft]`, read 2026-09-29: Shape (Text 240x16 with
 * radius/sm, Block 240x120 with radius/md, Circle 40x40 with radius/full). The defaults are the
 * drawn sizes; the caller overrides width and height through `className`, and the shape and radius
 * stay.
 *
 * Motion is the pulse and only the pulse: opacity, never a sweeping gradient, and every skeleton in a
 * region starts on the same frame because they mount together. UNDER REDUCED MOTION IT IS STILL,
 * unlike the reduced-motion spinner: a skeleton's pulse carries no meaning (the region's status text
 * does), so it is decoration, and decoration goes.
 */
export const skeletonRecipe = cva(
  ['ds-skeleton block bg-[var(--ds-skeleton-fill)]', 'animate-ds-pulse motion-reduce:animate-none'],
  {
    variants: {
      shape: {
        text: 'h-4 w-full rounded-sm',
        // 120 is the drawn height and is not a step on the spacing scale (which stops at 64), so it is
        // written as the value it is rather than as a class the scale guard rightly rejects.
        block: 'h-[120px] w-full rounded-md',
        circle: 'size-10 shrink-0 rounded-full',
      },
    },
    defaultVariants: { shape: 'text' },
  }
);

/** Several lines of text: bars stacked with x2 (8) between them. */
export const skeletonStackRecipe = cva('flex w-full flex-col gap-2');
